import React from "react";
import { useTranslation } from "react-i18next";

import { enMQType } from "../../../lib/classTalk/CodeEnum";

const FileShareMessage = ({ indexKey, msgInfo, handleSelectUrl }) => {
    const { t } = useTranslation();
    const downloadControlClassName = "btn btn-sm mx-1 px-2 py-1 yellow";
    const downloadControlStyle = { borderRadius: '0.5rem', textDecoration: 'none' };

    if (msgInfo.isDownloadButtonVisible === false) {
        return <></>;
    }

    // 20260901 추가: 믹스드 클라우드 파일은 준비 중에는 다운로드 버튼 대신 진행 표시를 보여준다.
    if (msgInfo.isMixedFilePreparing === true) {
        return (
            <div className="d-flex align-items-center w-100" style={{ paddingTop: '0.25rem', paddingLeft: '0.25rem' }}>
                <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true" />
                <span className="ms-2" style={{ fontSize: '0.75rem' }}>클라우드 파일 준비 중</span>
            </div>
        );
    }

    const getBtnText = (type) => {
        switch (type) {
            case enMQType.Video:
                return t("비디오", { ns: "classTalk" });

            case enMQType.Audio:
                return t("오디오", { ns: "classTalk" });

            case enMQType.InkMedia:
                return t("잉크미디어", { ns: "classTalk" });

            default:
                return t("열기", { ns: "common" });
        }
    }

    return (
        <div className="d-flex align-items-center w-100" style={{ paddingTop: '0.25rem', paddingLeft: '0.25rem' }}>
            {
                msgInfo.isDownloading ?
                    <>
                        <progress value={msgInfo.progress} max="100" />
                        <span style={{ fontSize: '0.6rem' }}>&nbsp;{msgInfo.progress + "%"}</span>
                    </> :
                    msgInfo.isDownloaded ?
                        <button type="button" className="btn btn-sm mx-1 px-2 py-1 hiclasstv-blue" style={{ borderRadius: '0.5rem', color: 'white' }} onClick={() => handleSelectUrl("file_open", msgInfo.urlInfo, indexKey, { type: msgInfo.type })}>
                            {getBtnText(msgInfo.type)}
                        </button> :
                        msgInfo.useNativeDownloadButton === false ?
                            // 20260908 수정: 일반 웹은 실제 링크를 직접 눌러 브라우저 다운로드를 시작한다.
                            <a className={downloadControlClassName} style={downloadControlStyle} href={msgInfo.urlInfo} download={msgInfo.originalFileName || undefined}>
                                {t("다운로드", { ns: "info" })}
                            </a> :
                            <button type="button" className={downloadControlClassName} style={downloadControlStyle} onClick={() => handleSelectUrl(msgInfo.kind, msgInfo.urlInfo, indexKey, msgInfo)}>
                                {t("다운로드", { ns: "info" })}
                            </button>
            }
        </div>
    );
}

export default FileShareMessage;
